import { Component, OnInit, Input, Injector, AfterViewInit } from '@angular/core';
import { MainComponent } from 'src/modules/base/components/main-component/main.component';
import { Router, ActivatedRoute } from '@angular/router';
import { DynamicPopUpComponent } from 'src/modules/base/components/data-grid/dynamic-pop-up/dynamic-pop-up.component';
import { ModalSize } from 'src/modules/base/services/smart-modal.service';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';

@Component({
    selector: 'app-prescription-print',
    templateUrl: './prescription-print.component.html',
    styleUrls: ['./prescription-print.component.scss'],
    standalone: false
})
export class PrescriptionPrintComponent extends MainComponent implements OnInit {
  @Input() data: any;
  @Input() action: any;
  currentData: any = {};
  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public dialogConfig: DialogConfig
  ) {super(injector, route); }

  // ngAfterViewInit(): void {
  //   setTimeout(() =>
  //     this.loader.showSpinner()
  //     , 100);
  // }

  ngOnInit() {
    console.log("Data ", this.dialogConfig.data);
    console.log("Data ", this.data);
    this.currentData.showView = false;
    if(this.route.snapshot!=undefined && this.route.snapshot.queryParams!=undefined && this.route.snapshot.queryParams.returnUrl!=undefined && this.route.snapshot.queryParams.returnUrl.includes('opbilling_format')){
      this.data=this.dialogConfig.data;
      
      this.action={
        "action": "popup_form",
        "isUserPrint": true,
        "isNoOfPrintCopy": true,
        "label": "button.PrescriptionPrint",
        "permission_required":false,
        "selector": "app-prescription-print",
        "pre_print": true,
        "pre_print_check": true,
        "visible":false,
        "popup": {
          "size": "sm",
          "title": "Print Prescription"
      }
    }
  }
    this.getOrders();
  }
  getOrders(){
    let data = {
      "args":"bill_no:" + this.data.bill_no + ",admissionId:" + this.data.admissionId,
      "query_id": "GET_DATA_FOR_REFUND"
    }
    this.baseService.getData(data, "", 'payment_refund', 'billing', 'GET_DATA_FOR_REFUND').subscribe(
      result => {
        if(result.errCode == 0 && result.resource.length > 0){
          if(result.resource[0].data.length > 0){
            this.currentData.allData = result.resource[0].data;
            this.currentData.filterData = result.resource[0].data.filter(x => x['serviceType_code'] == 'op_consultation');
            this.currentData.showView = true;
            if(this.currentData.filterData.length >1 ){
              // this.loader.hideSpinner();
            } else {
              let args = "bill_no:"+this.data.bill_no+",admissionId:"+this.data.admissionId+",uhId:"+this.data.uhId+",reportTemplateId:PrescriptionPrint"
              if ((this.action  != undefined && this.action.pre_print != undefined && this.action.pre_print) || (this.action  != undefined && this.action.isUserPrint != undefined && this.action.isUserPrint == true)) {
                this.dialogRef.close();
                // this.loader.hideSpinner();
                console.log("Inside getOrders for preprint::::!!!");
                // this.prePrint(this.action,"",args);
                this.printTemplateSettingDetails(this.action,"",args);
              }
              else{
              this.handleFile(args, this.data, (res) => {
                if (!res) {
                  this.alerts.error("Print Error");
                } else {
                  this.dialogRef.close();
                }
              });
              }
            }
            console.log("Filter Data ", this.currentData.filterData);
          }
        }else{
        }
    });
  }
  prePrint(action, val, args, res?) {
    // this.loader.hideSpinner();
    /* let prePrintObj = action.pre_print;
    action['form'] = action.pre_print.form;*/
    let isPrePrintAction = true;
    let print_without_h_f = this.appService._currentSessionData.print_without_h_f;
    if(res && res.print_without_h_f != null){
        print_without_h_f = res.print_without_h_f;
    }
      console.log("print_without_h_f::::!!!",print_without_h_f);
      let defaultPrint = "Y";
      let isNoOfPrintCopy = false;
      // isNoOfPrintCopy = this.appService.getAccountConfigValue('MultiplePrintCopy') != undefined && action?.isNoOfPrintCopy == true;

      let override_print_copies = true;

      if (res?.no_of_print_copy > 1) {
          isNoOfPrintCopy = true;
      }

      if (res?.override_print_copies === true) {
          override_print_copies = false;
      }

      if (action.isGrid !=undefined && action.isGrid == true) {
          isNoOfPrintCopy = false;
      }

      if(print_without_h_f!= undefined && print_without_h_f==true){
        defaultPrint="N";
      }
      if (action && action.isUserPrint != undefined && action.isUserPrint == true && action && action.isPrePrintAction != undefined && action.isPrePrintAction == true) {
          isPrePrintAction = true;
      }
      if (action && (action.isUserPrint != undefined && action.isUserPrint == true) || (action.isGrid !=undefined && action.isGrid == true )) {
          let pre_print = {
                 "title": "",
                 "form": {
                   "buttons": {
                     "Add": [
                       {
                         "label": "Print",
                         "action": "prePrint"
                       }
                     ]
                   },
                   "blocks": [
                     {
                       "name": "pre_print",
                       "class_name": "null",
                       "layout_type": "no-column",
                       "order": 1,
                       "fields": [
                         {
                             "label": "Select Print Header & Footer Type?",
                             "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                             "order": 2,
                             "type": "String",
                             "component": "dropdown",
                             "name": "userPrint",
                             "default": defaultPrint,
                             "datasource": {
                                 "possible_value": [
                                     {
                                         "id": "Y",
                                         "value": "With Header & Footer"
                                     },
                                     {
                                         "id": "N",
                                         "value": "Without Header & Footer"
                                     }
                                 ]
                             }
                         },
                         {
                          "label": "Select Layout Type?",
                          "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                          "order": 2,
                          "type": "String",
                          "component": "dropdown",
                          "name": "page_layout",
                          "default": "portrait",
                          "visible": isPrePrintAction,
                          "datasource": {
                              "possible_value": [
                                  {
                                      "id": "landscape",
                                      "value": "Landscape"
                                  },
                                  {
                                      "id": "portrait",
                                      "value": "Portrait"
                                  }
                              ]
                          }
                        },
                        {
                            "label": "No of Print Copy",
                            "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                            "order": 3,
                            "type": "Integer",
                            "visible": isNoOfPrintCopy,
                            "disabled": override_print_copies,
                            "component": "numberbox",
                            "name": "no_of_print_copy",
                            "default": res?.no_of_print_copy ?? 1
                        }
                       ]
                     }
                   ]
                 }
             };
             var prePrintObj = pre_print;
             action['form'] = pre_print.form;
         }
         else{
              prePrintObj = action.pre_print;
         action['form'] = action.pre_print.form;
         }
    let obj: any = Object.assign({ action }, { val });
    this.smartModalService.open(DynamicPopUpComponent, obj, prePrintObj.title != undefined ? prePrintObj.title : "", ModalSize.Md).subscribe(res => {
      if(res && res.result &&  res.result.no_of_print_copy){
        args = args + ',no_of_print_copy:' + res.result.no_of_print_copy;
      } 
        if (res && res.result.userPrint) {
          args = args + ",userPrint:" + res.result.userPrint;
          this.handleFile(args, this.data, (res) => {
            if (!res) {
              this.alerts.error("Print Error");
            } else {
              this.dialogRef.close();
            }
          });
        }
    },
      err => {
        console.log("err");
      }
    );
  }
  handleFile(args, obj, callback = null) {
    this.loader.showSpinner();
    var fileObj = {
      "application": "billing",
      "template": "PrescriptionPrint",
      "resource": "billing_item",
      "query_id": "ITEMS_FOR_OP_BILL",
      "contentType": "pdf",
      "args": args,
      "file_type": "pdf",
      "queryId": 'print'
    }
    this.baseService.handleFile(fileObj, (fileData) => {
      if (fileData) {
        fileObj['key'] = obj.id;
        this.printService.handleFileReponse(fileObj, 'print', fileData, callback);
      } else {
        this.alerts.error('server error');
        if (callback) {
          callback(false);
        }
      }
      this.loader.hideSpinner();
    }, (error) => {
      this.loader.hideSpinner();
      this.alerts.error('server error');
      if (callback) {
        callback(false);
      }
    });
  }
  valueChange(data){
    // console.log("Data is ", data);
    this.currentData.selectedData = data;
    let args = "bill_no:"+this.data.bill_no+",admissionId:"+this.data.admissionId+",uhId:"+this.data.uhId+",consultant:"+data.serviceId+",reportTemplateId:PrescriptionPrint"
    if ((this.action != undefined && this.action.pre_print != undefined && this.action.pre_print && this.action.pre_print_check) || (this.action.isUserPrint != undefined && this.action.isUserPrint && this.action.pre_print_check)){
      // this.prePrint(this.action,"",args);
      this.printTemplateSettingDetails(this.action,"",args);
    }
    else{
    this.handleFile(args, this.data, (res) => {
      if (!res) {
        this.alerts.error("Print Error");
      } else {
        //this.dialogRef.close();
      }
    });
    }
  }
  printTemplateSettingDetails(action, val, args) {
    // this.action = action;
     try {
        console.log("Inside PTS Condition prescription");
        let templateId = action?.file_data?.template;
        if (!templateId && args!=null && args !=undefined) {
          templateId = this.utilService.extractValueFromArgs(args, 'reportTemplateId');
        }
        this.utilService.performPreprintAction(
          this.baseService,
          action,
          (res: any) => this.prePrint(action,"",args,res),
          (res: any) => {
            if (args != null) {
                args += `,userPrint:${res}`;
            } else {
                args = `userPrint:${res}`;
            }
            this.handleFile(args, this.data, (data) => {
              if (!data) {
                this.alerts.error("Print Error");
              } else {
                this.dialogRef.close();
              }
            });
          },
          templateId,
          false
        )
      } catch (err) {
          console.error("Unexpected error in match block:", err);
          this.prePrint(action,"",args);
      } 
  }
  isRadioSelected(id){
    if(this.currentData.selectedData != undefined)
      return (this.currentData.selectedData.id == id);
    else
    return false;
  }
}